module.exports = __webpack_public_path__ + "static/media/background-city.c71e3771.jpg";